  <div class="step-preview">
    <div class="step-preview-steps">
      <div  
        *ngFor='let step of steps$ | async' 
        class="step-preview-steps-item"
        [style.background]="stepsStylingMap.get(step.target_type).subCountractStepColor"
        >
        <mat-icon class="black-icon" style="width:18px;" [svgIcon]="stepsStylingMap.get(step.target_type).stepIcon"></mat-icon>
        <div class="step-preview-steps-item-name">{{step.name}}</div>
      </div>
    </div>
    <div class="step-preview-buttons">
      <div class="step-preview-buttons-fr">
        <button  class="button-icon size-m primary-button" (click)="viewSubContractInDialog()"
          [disabled]="!this.contractStep?.target_key" >
          <mat-icon svgIcon="information-line"> </mat-icon>
          <span>
            {{'CONTRACTS.CARD.INFO'|translate}}
          </span>
        </button>
        <button  class="button-icon size-m primary-button" 
          [disabled]="
            contractData?.rights?.isCurrentMemberCanAddTargetsAfter === false || 
            (this.contractData?.contract?.contract.status === 'verified' && contractStep?.target?.target_key)" 
          (click)="addSubContract()" >
            <mat-icon [svgIcon]="contractStep?.target?.target_key? 'edit-2-fill' : 'add-circle-fill' "> </mat-icon>
          <span>
            {{(contractStep?.target?.target_key? 'CONTRACTS.CARD.EDIT' : 'CONTRACTS.CARD.ADD')|translate}}
          </span>
        </button>
      </div>
    </div>
    <div class="step-preview-parties">
      <div class="step-preview-parties-signed" *ngIf="singedMembers?.length">
        <div class="step-preview-parties-title">{{'CONTRACTS.CARD.SIGNED'| translate}}</div>
        <div class="step-preview-parties-signed-users" >
          <app-contract-avatar *ngFor="let guid of singedMembers"
            [avatarSize]="'42px'"
            [userGuid]="guid" 
            [checkedState]="true">
          </app-contract-avatar>
        </div> 
      </div>
      <div class="step-preview-parties-not_signed" *ngIf="notSingedMembers?.length">
        <div class="step-preview-parties-title">{{'CONTRACTS.CARD.NOT_SIGNED'| translate}}</div>
          <div class="step-preview-parties-not_signed-users" >
            <app-contract-avatar *ngFor="let guid of notSingedMembers"
              [avatarSize]="'42px'"
              [userGuid]="guid" 
              [checkedState]="false">
            </app-contract-avatar>
          </div>
      </div>
    </div>
  </div>
